export const closeOverlay = () => {
    return {
        type: 'OMMIT_OVERLAY',
        payload: false
    }
};

export const ommitItem = (data) => {
    return {
        type: 'OMMITTED_ITEM',
        payload: data,
    }
};

export const itemPriorityChange = (data) => {
    return {
        type: 'PRIORITIES_ITEM_CHANGE',
        payload: data
    }
};

export const overlapOpen = (open, id) => {
    return {
        type: 'CANDIDATE_OPEN',
        open: open,
        candidate_id: id,
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/OmmitOverlay/actions.js